import script from "./SubscriptionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=327194ba&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327194ba"]])

export default __exports__